import { SearchType } from '@brightdrop/bd-ui';

export const FIXED_COLUMN_MIN_WIDTH = 130;
export const DATE_COLUMN_MIN_WIDTH = FIXED_COLUMN_MIN_WIDTH;
export const STATUS_COLUMN_MIN_WIDTH = FIXED_COLUMN_MIN_WIDTH;
export const RATE_COLUMN_MIN_WIDTH = FIXED_COLUMN_MIN_WIDTH;
export const TABLE_COLUMN_MIN_WIDTH = 150;
export const VIN_COLUMN_MIN_WIDTH = 180;
export const VEHICLE_NAME_COLUMN_MIN_WIDTH = 280;

export const COMPACT_VEHICLE_NAME_MIN_WIDTH = 200;
export const COMPACT_COLUMN_MIN_WIDTH = 120;
export const COMPACT_RATE_COLUMN_MIN_WIDTH = 110;

export const CHECKBOX_COLUMN_WIDTH = '5%';
export const DEFAULT_SEARCH_TYPES = [SearchType.MULTIPLE_SEARCH];
export const BPS_TABLE_MAX_HEIGHT = '60vh';
